import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage
import quotesReducer from './quotesSlice';

/**
 * Redux Persist configuration
 * Persists the entire quotes slice to localStorage
 */
const persistConfig = {
  key: 'self-motivation-app', // localStorage key
  version: 1,
  storage,
  whitelist: ['quotes'], // Only persist quotes slice
};

/**
 * Combine reducers
 * Currently only quotes, but allows easy expansion
 */
const rootReducer = combineReducers({
  quotes: quotesReducer,
});

/**
 * Wrap root reducer with persistence
 */
const persistedReducer = persistReducer(persistConfig, rootReducer);

/**
 * Configure Redux store with persistence middleware
 */
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions for serializable check
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

/**
 * Create persistor for PersistGate
 */
export const persistor = persistStore(store);

/**
 * Type definitions for TypeScript
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
